module.exports = __webpack_public_path__ + "static/media/tunisia.fbc27d08.webp";